import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { CopyDeleteOverlay, CopyDeleteContent, CopyDeleteItem } from '../sidebar/notes/modals/copy-delete/copy-delete.styled';

type Props = {
  open: boolean;
  onClose: () => void;
  onDownload: () => void;
  onViewInConversation: () => void;
  onDelete: () => void;
  anchorRect: DOMRect | null;
};

export const FileOptionsModal: React.FC<Props> = ({
  open,
  onClose,
  onDownload,
  onViewInConversation,
  onDelete,
  anchorRect,
}) => {
  const MODAL_HEIGHT = 130; // approximate: 102px content + padding + border

  const positionStyle = React.useMemo(() => {
    if (!anchorRect) return {};
    const spaceBelow = window.innerHeight - anchorRect.bottom;
    if (spaceBelow < MODAL_HEIGHT + 8) {
      // Not enough room below — flip above the anchor
      return {
        top: 'auto',
        bottom: `${window.innerHeight - anchorRect.top + 8}px`,
        left: `${anchorRect.right}px`,
        transform: 'translateX(-100%)',
      };
    }
    return {};
  }, [anchorRect]);

  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <CopyDeleteOverlay />
        <CopyDeleteContent anchorRect={anchorRect} style={{ height: 'auto', ...positionStyle }} aria-describedby={undefined}>
          <Dialog.Title style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' }}>
            File options
          </Dialog.Title>
          <CopyDeleteItem
            type="button"
            onClick={() => {
              onDownload();
              onClose();
            }}
          >
            Download
          </CopyDeleteItem>
          <CopyDeleteItem
            type="button"
            onClick={() => {
              onViewInConversation();
              onClose();
            }}
          >
            View in conversation
          </CopyDeleteItem>
          <CopyDeleteItem
            type="button"
            onClick={onDelete}
            style={{ color: '#E57373' }}
          >
            Delete
          </CopyDeleteItem>
        </CopyDeleteContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
